const theme = {
  dark: {
    default: {
      icon: '#232323',
      stick: '#0B0B0B',
      text: '#FFFFFF',
    },
    active: {
      icon: '#FFFFFF',
      stick: '#FFFFFF',
      text: '#0B0B0B',
    },
  },
  light: {
    default: {
      icon: '#EBEBEB',
      stick: '#EBEBEB',
      text: '#0B0B0B',
    },
    active: {
      icon: '#0B0B0B',
      stick: '#0B0B0B',
      text: '#FFFFFF',
    },
  },
}

export default theme
